import { retrieveErrorFromApi } from '../../../../helper'
import { setSumOrders } from '../../../action/order'
import { setAppErrors } from '../../../action/system'
import calculateAllOrderSum from '../../../axios/orderview/calculateAllOrderSum'

export const calculateAllOrderSumThunk = (dateFrom, dateTo, paymentMethod, status, orderType, processedByUsername, processedByUsernameWithEmpty) => dispatch => {
	const modifiedPaymentMethod = paymentMethod === 'EC_TERMINAL' ? 'EC_TERMINAL,TAP_TO_PAY' : paymentMethod
	return calculateAllOrderSum(dateFrom, dateTo, modifiedPaymentMethod, status, orderType, processedByUsername, processedByUsernameWithEmpty)
		.then(res => {
			dispatch(setSumOrders(res.data.sumOrders))
		}).catch(error => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}
